import React from 'react';
import { Shield } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-20 px-4 bg-brand-green text-white relative overflow-hidden" data-id="element-152">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-153"></div>

      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center gap-8" data-id="element-154">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="w-44 h-44 shrink-0 bg-white rounded-full flex flex-col items-center justify-center text-brand-green shadow-2xl border-8 border-white/20" data-id="element-155">
          <Shield size={56} className="mb-1" data-id="element-156" />
          <span className="font-black text-3xl leading-none" data-id="element-157">7</span>
          <span className="font-bold uppercase tracking-widest text-sm" data-id="element-158">
            DÍAS
          </span>
        </motion.div>

        <h2 className="text-3xl sm:text-5xl font-black tracking-tight" data-id="element-159">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <p className="text-xl font-medium text-white/90" data-id="element-160">
          Abrís los tomos. Los usás. Aplicás el protocolo.
        </p>

        <p className="text-lg leading-relaxed" data-id="element-161">
          Si en 7 días no es exactamente lo que esperabas:
          <br data-id="element-162" />
          <strong className="text-3xl block mt-3" data-id="element-163">devolución del 100%</strong>
          <span className="text-white/80 text-sm uppercase tracking-widest mt-3 block" data-id="element-164">
            sin formularios · sin drama · sin explicaciones
          </span>
        </p>

        <div className="inline-block bg-black/20 px-4 py-2 rounded-lg text-sm font-medium backdrop-blur-sm" data-id="element-165">
          Tasa de devoluciones: menos del 1%.
        </div>
      </div>
    </section>;
}